module.exports = __webpack_public_path__ + "static/media/ricetta.7dbf3bb1.svg";